import {
  IN_PROGRESS_PROJECT,
  COMPLETED_PROJECT,
  SEMI_COMPLETED_PROJECT,
  PENDING_PROJECT,
  LOST_PROJECT,
  NOT_PAID
} from '@/constants/projectStatuses'

const tabs = [
  {
    id: IN_PROGRESS_PROJECT.id,
    title: 'Active'
  },
  {
    id: SEMI_COMPLETED_PROJECT.id,
    title: 'Semi-completed'
  },
  {
    id: PENDING_PROJECT.id,
    title: 'Pending'
  },
  {
    id: NOT_PAID.id,
    title: NOT_PAID.title
  },
  {
    id: COMPLETED_PROJECT.id,
    title: 'Completed'
  },
  {
    id: LOST_PROJECT.id,
    title: 'Deleted'
  }
]

export default tabs



// WEBPACK FOOTER //
// ./src/constants/tabs.js